const zh_CN = {
  lang: 'English',

  yes: '是',
  no: '否',

  home: '主页',
  dashboard: '控制台',
  signIn: '登陆',
  signUp: '注册',
  signOut: '登出',
  defaultEmail: '默认邮箱',
  notification: '通知',
  setting: '设置',

  unknownError: '未知错误！',

  userInfoNotExist: '用户信息不存在！',

  sentryFailGet: '读取Sentries失败！',

  notificationSuccessAdd: '添加成功！',
  notificationFailAdd: '添加通知失败！',
  notificationFailGet: '读取通知失败！',
  notificationInvalidString: 'The input is not valid string!',
  notificationServerChanName: 'Please input your ServerChan name!',
  notificationServerChanSCKEY: 'Please input your SCKEY!',

  dashboardSidebarHome: 'Sentries',
  dashboardSidebarNotifications: '通知方式',
  dashboardSidebarSetting: '设置',

  sentryRemoveText: '你想要移除这条嘛？',

  sentryDetailInputName: 'Please input sentry name!',
  sentryDetailInputInterval: 'Please input sentry interval',
  sentryDetailSuccessUpdate: '更新成功！',

  timeZoneDiffNotice: '浏览器时区与当前用户设置不符!',
};
export default zh_CN;
